import { useContext } from "react";
import { MdArrowForward } from "react-icons/md";
import { AppContext } from "../App";
import PageHero from "./PageHero";
import CallToAction from "./callToAction";
import constructionTwo from "../assets/construction2.png";
import constructionThree from "../assets/construction3.png";
import buildingImage from "../assets/building construction (1).jpg";
import civilImage from "../assets/civil engineering (1).jpg";
import designImage from "../assets/construction design (1).jpg";
import kigamboni from "../assets/kigamboni.jpeg";
import kigamboni1 from "../assets/kigamboni1.jpeg";
import kigamboni2 from "../assets/kigamboni2.jpeg";
import kigamboni3 from "../assets/kigamboni3.jpeg";
import moro1 from "../assets/moro1.jpeg";
import moro2 from "../assets/moro2.jpeg";
import moro3 from "../assets/moro3.jpeg";
import kipawa from "../assets/kipawa.jpeg";
import kipawa1 from "../assets/kipawa1.jpeg";
import kipawa2 from "../assets/kipawa2.jpeg";
import kipawa3 from "../assets/kipawa3.jpeg";
import kg1 from "../assets/kg1.jpeg";
import kg2 from "../assets/kg2.jpeg";
import kg3 from "../assets/kg3.jpeg";
import max1 from "../assets/max1.jpeg";
import max2 from "../assets/max2.jpeg";
import max3 from "../assets/max3.jpeg";
import dodoma1 from "../assets/dodoma1.jpeg";
import dodoma2 from "../assets/dodoma2.jpeg";
import dodoma3 from "../assets/dodoma3.jpeg";

export const projects = [
  {
    slug: "proposed-wall-fencing",
    name: "Proposed Wall Fencing at Kigamboni",
    status: "Completed and handed over",
    client: "Private",
    value: "45,000,000 Tshs",
    location: "Kigamboni",
    category: "Building construction",
    description:
      "A fencing project completed and handed over with SMART TGM Limited supporting construction execution and site coordination.",
    image: kigamboni,
    images: [kigamboni1, kigamboni2, kigamboni3],
  },
  {
    slug: "residential-building-bunju",
    name: "Proposed Office Finishing at Kipawa",
    status: "Completed and handed over",
    client: "Private",
    value: "30,000,000 Tshs (labour only)",
    location: "Kipawa, Dar es Salaam",
    category: "Office Finishing",
    description:
      "Residential building works including stone cladding, completed and handed over with attention to workmanship and finish quality.",
    image: kipawa,
    images: [kipawa1, kipawa2, kipawa3],
  },
  {
    slug: "three-d-mesh-fence",
    name: "Proposed 3D Mesh Fence",
    status: "Completed / ongoing scopes",
    client: "Lumuzo Estate Ltd",
    value: "40,000,000 Tshs",
    location: "Morogoro",
    category: "Specialized construction",
    description:
      "Specialized fencing works for estate and boundary requirements, reflecting SMART TGM Limited's capability in focused construction packages.",
    image: moro1,
    images: [moro1, moro2, moro3],
  },
  {
    slug: "industrial-construction",
    name: "Proposed Industrial Construction",
    status: "Completed",
    client: "Private",
    value: "32,000,000 Tshs (labour only)",
    location: "Kigamboni, Dar es salaam",
    category: "Building works",
    description:
      "Industrial construction completed as specialized in building scope with practical site supervision and delivery control.",
    image: kg1,
    images: [kg1, kg2, kg3],
  },
  {
    slug: "office-building-finishing",
    name: "Office Building Finishing Works",
    status: "Completed",
    client: "Max Steel Ltd",
    value: "51,252,040 Tshs (labour only)",
    location: "Tanzania",
    category: "Commercial construction",
    description:
      "Office building finishing works completed for a commercial client, showing capability in internal and final-stage construction scopes.",
    image: max1,
    images: [max1, max2, max3],
  },
  {
    slug: "aluminium-partition",
    name: "Aluminium Partition",
    status: "Completed",
    client: "Road Fund Board - Dodoma",
    value: "15,500,000 Tshs",
    location: "Dodoma",
    category: "Office Partitioning",
    description:
      "Office partitioning project completed for an organization, demonstrating designinng skills and site execution capability.",
    image: dodoma1,
    images: [dodoma1, dodoma2, dodoma3],
  },
];

export function getProjectBySlug(slug) {
  return projects.find((project) => project.slug === slug);
}

export default function ProjectsContent() {
  const appContext = useContext(AppContext);

  return (
    <>
      <PageHero
        eyebrow="Projects"
        title="Project experience across civil, building, and specialized works."
        text="SMART TGM Limited's profile includes warehousing, residential works, fencing, roofing, cladding, partitioning, and boundary wall projects."
        image={civilImage}
      />

      <section className="tgm-section tgm-projects-page" data-aos="fade-up">
        <div className="container">
          <div className="tgm-section-head">
            <div>
              <p className="tgm-section-kicker">Execution Experience</p>
              <h2>Work highlights from the company profile.</h2>
            </div>
            <p>
              These examples show the range of scopes SMART TGM Limited has
              handled through construction planning, site coordination, and
              quality-focused execution.
            </p>
          </div>

          <div className="tgm-project-grid">
            {projects.map((project, index) => (
              <article
                className="tgm-project-card"
                key={project.name}
                role="button"
                tabIndex="0"
                data-aos="fade-up"
                data-aos-delay={index * 55}
                onClick={() =>
                  appContext.navTo({
                    item: "projects",
                    subItem: project.slug,
                  })
                }
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    appContext.navTo({
                      item: "projects",
                      subItem: project.slug,
                    });
                  }
                }}
              >
                <div className="tgm-project-card-image">
                  <img src={project.image} alt={project.name} />
                </div>
                <div className="tgm-project-card-body">
                  <div>
                    <h3>{project.name}</h3>
                    <p>{project.status}</p>
                  </div>
                  <button
                    type="button"
                    aria-label={`View ${project.name}`}
                    onClick={(event) => {
                      event.stopPropagation();
                      appContext.navTo({
                        item: "projects",
                        subItem: project.slug,
                      });
                    }}
                  >
                    <MdArrowForward />
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <CallToAction />
    </>
  );
}
